import { Component, ElementRef, Input, OnDestroy, OnInit } from '@angular/core';
import { map, skip, take, takeUntil } from 'rxjs';

import { HourDetailsService } from './hour-details.service';
import { opacityFade } from '@hiptraveler/animations';
import { HourDetails } from './hour-details.interface';
import { animationDelay } from '../../common';

@Component({
  selector: 'hour-details',
  templateUrl: './hour-details.component.html',
  styleUrls: ['./hour-details.component.scss'],
  host: { class: 'content' },
  viewProviders: [ HourDetailsService ],
  animations: [ opacityFade(animationDelay) ]
})
export class HourDetailsComponent implements OnInit, OnDestroy {

  @Input() isHotel: boolean = false;

  hourDetails: HourDetails[] = [];

  constructor(
    private element: ElementRef<HTMLElement>,
    public service: HourDetailsService
  ) { }

  ngOnInit(): void {
    if (this.isHotel) {
      this.handleHotelHours();
      return;
    }

    this.handleImageInfoHours();
  }

  ngOnDestroy(): void {
    this.service.subscription$.next();
  }

  private handleHotelHours(): void {
    this.service.hotelInformation$.pipe(
      takeUntil(this.service.subscription$),
      map((response) => {
        const visibility = this.service.hasHotelHours(response);
        
        if (visibility) {
          this.hourDetails = this.service.mapHotelHours(response);
        }
        
        visibility || (this.element.nativeElement.style.display = 'none');
      })
    ).subscribe();
  }

  private handleImageInfoHours(): void {
    this.service.imageInformation$.pipe(
      skip(1),
      takeUntil(this.service.subscription$),
      map((response) => {
        const visibility = this.service.hasHours(response);
        
        if (visibility) {
          this.hourDetails = this.service.mapHoursToModel(response);
        }
        
        visibility || (this.element.nativeElement.style.display = 'none');
      }),
      take(1)
    ).subscribe();
  }
}
